import { useNavigate } from "react-router";
import SyIcon from "../../../../shared/components/sy-icon";

import styleSheet from "./style.module.scss";
import { useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getOrbitDetails } from "../../../../feature/orbit-slice";
import { orbitParamValue } from "../../../../utils/helper";
import CitizenInvitePop from "../citizen-invite-popup";
import { table_header } from "./config";
import { useMutation } from "@tanstack/react-query";
import planetService from "../../services/planet-service";
import { getImageDetails } from "../../../../feature/image-slice";
import { OrbToast } from "../../../../utils/orb-toast";
import { useTranslation } from "react-i18next";
import SyTooltip from "../../../../shared/components/sy-tooltip";

const CitizenRequestPop = (props: any) => {
  const { data, onClose } = props;
  const navigate = useNavigate();
  const orbitInfo = useSelector(getOrbitDetails);
  const [searchParams] = useSearchParams();
  const [params, setParams] = useState<any>(orbitParamValue(searchParams));
  const imageDetails = useSelector(getImageDetails);
  const [requestList, setRequestList] = useState<any>([]);
  const { t } = useTranslation();

  const getTableHeaders = ({ th_classname, th_name, index }: any) => {
    return (
      <th key={index} className={`${th_classname} text-truncate`} scope="col">
        {t(th_name)}
      </th>
    );
  };

  const navPlanetDetails = (id: any) => {
    navigate(`/view/planet/${orbitInfo.selectOrbit}/${id}`);
  };

  const onActionClick = (action: any) => {
    const payload = {
      orb_id: orbitInfo.selectOrbit,
      action: action,
    };
    planetApproval(payload);
  };

  const setApprovalList = () => {
    const payload = {
      orb_id: orbitInfo.selectOrbit,
    };
    getApprovalList(payload);
  };

  const { mutate: getApprovalList } = useMutation({
    mutationFn: planetService.getApprovalList,
    onSuccess(data, variables, context) {
      setRequestList(data.data);
    },
  });
  const { mutate: planetApproval } = useMutation({
    mutationFn: planetService.planetApproval,
    onSuccess(data, variables, context) {
      setApprovalList();
      OrbToast(t(data.data.message), "top-right", "short", "default");
    },
  });

  useEffect(() => {
    setApprovalList();
  }, []);

  const getTableContent = ({ data, index }: any) => {
    return (
      <tr key={index} className="lh-lg">
        <td className="text-center position-sticky start-0 table-cell-bg text-truncate">
          <img
            className={`rounded-circle`}
            width={"40px"}
            src={data.category_image || imageDetails.default[0].img}
          />
        </td>
        <td className="text-truncate">{data.usr_name}</td>

        <td className="text-truncate">{data.usr_email}</td>
        <td className="text-truncate">{data.usr_phone}</td>
        <td className="text-truncate">
          <img
            className={`rounded-circle`}
            width={"40px"}
            src={data.category_image}
          />
        </td>
        <td className="text-truncate">{data.pro_name}</td>
        <td className="text-truncate">
          <SyTooltip title={t("accept")}>
            <SyIcon
              name="thumb_up"
              iconType="symbols"
              iconStyle="outlined"
              iconColor="white"
              className={` pointer`}
              onClick={() => onActionClick("approve")}
            />
          </SyTooltip>
          <SyTooltip title={t("reject")}>
            <SyIcon
              name="thumb_down"
              iconType="symbols"
              iconStyle="outlined"
              iconColor="white"
              className={` pointer`}
              onClick={() => onActionClick("reject")}
            />
          </SyTooltip>
        </td>
      </tr>
    );
  };

  return (
    <>
      <div className={`rounded-4  p-3 pop-bg ${styleSheet.main}`}>
        <div className="d-flex align-items-center justify-content-between pb-3">
          <h2 className="mohave m-0 title-font"> {t("request_details")}</h2>
          <SyIcon
            name="close"
            iconType="symbols"
            iconStyle="outlined"
            iconColor="white"
            className={` pointer`}
            onClick={onClose}
          />
        </div>
        <div className="mt-3">
          <table className={`${styleSheet.table_style} w-100`}>
            <thead className="lh-lg mohave-bold ">
              <tr>
                {table_header.map((data: any, index: number) =>
                  getTableHeaders({ ...data, index: index })
                )}
              </tr>
            </thead>
            <tbody className="position-relative mohave">
              {requestList.length ? (
                requestList.map((data: any, index: number) =>
                  getTableContent({ data, index: index })
                )
              ) : (
                <div className=" position-absolute position-absolute mt-5 end-50">
                  <p> {t("no_data_found")}</p>
                </div>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CitizenRequestPop;
